import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo, WhatsAppIcon } from "./Brand";
import { scrollToId, EASE } from "../../lib/site";
import { useQuiz } from "../../hooks/QuizContext";

const LINKS = [
  { id: "beneficios", label: "Benefícios" },
  { id: "como-funciona", label: "Como funciona" },
  { id: "areas", label: "Áreas" },
  { id: "agendamento", label: "Orçamento" },
  { id: "duvidas", label: "Dúvidas" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openQuiz } = useQuiz();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, id) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled || open ? "bg-[#FAF5EE]/80 shadow-[0_8px_30px_-12px_rgba(45,28,24,0.18)] backdrop-blur-xl" : ""
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <a href="#topo" onClick={(e) => go(e, "topo")} aria-label="Aisla Studio — voltar ao início" data-testid="header-logo-link">
          <Logo id="lotus-header" />
        </a>
        <nav aria-label="Navegação principal" className="hidden items-center gap-9 lg:flex">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={(e) => go(e, l.id)} className="nav-link" data-testid={`nav-link-${l.id}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => openQuiz("header")}
            className="btn-rose btn-sm hidden sm:inline-flex"
            data-testid="header-cta-whatsapp"
          >
            <WhatsAppIcon className="h-4 w-4" /> Agendar
          </button>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="grid h-11 w-11 place-items-center rounded-full border border-[#2D1C18]/15 text-[#2D1C18] lg:hidden"
            aria-expanded={open}
            aria-controls="mobile-menu"
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav id="mobile-menu" aria-label="Navegação móvel" className="border-t border-[#2D1C18]/10 px-5 pb-6 pt-2 lg:hidden" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} onClick={(e) => go(e, l.id)} className="block border-b border-[#2D1C18]/10 py-4 font-display-serif text-2xl text-[#2D1C18]" data-testid={`mobile-nav-link-${l.id}`}>
              {l.label}
            </a>
          ))}
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              openQuiz("mobile_menu");
            }}
            className="btn-rose mt-5 w-full justify-center"
            data-testid="mobile-menu-cta"
          >
            <WhatsAppIcon className="h-4 w-4" /> Agende sua sessão
          </button>
        </nav>
      )}
    </motion.header>
  );
};
